import { OrderDetails, ProductProperty } from "../../interface/interfaces";
// import './renderproperty.scss';

type Prop = {
    prop: ProductProperty,
    propId: number,
    setOrder: React.Dispatch<React.SetStateAction<OrderDetails>>
}

const RenderProperty = ({ prop, propId, setOrder }: Prop) => {


    // const handlePropSelect=(id:number)=>{
    //     let selected:SelectedProductProperty[]=[]


    //     setOrder((prev)=>{ 
    //             let clone={...prev} 

    //             let properties=clone.properties as ProductProperty[]
    //             // let selectedProperty=clone.selectedProperties

    //             if(properties){

    //                 let propValues=properties[propId].values

    //                 propValues.forEach((data,index)=>{
    //                      let trueCheck=index === id

    //                      if(trueCheck){

    //                         let selVal=data.value
    //                         let selType=properties[propId].type
    //                         let selName=properties[propId].name


    //                         const hasProp = selected.find(data => data.type === selType );

    //                         if(hasProp){
    //                            hasProp.value=selVal
    //                         }else{
    //                            selected.push({
    //                             name:selName,
    //                             type:selType,
    //                             value:selVal
    //                         })
    //                         }
    //                      }

    //                     data.isSelected = trueCheck
                        
    //                 })
   
    //             }
                
                
    //             clone.selectedProperties=selected

                
    //             console.log('Clone',clone)
    //             console.log('Selected',selected)
    
    //             return {
    //                 ...clone,
    //             }          
    //     })

    // }

    const handlePropSelect = (id: number) => {
        setOrder(prev => {
          const clone = { ...prev };
          const properties = clone.properties;
          const selectedProperties = [...(clone.selectedProperties || [])];
      
          if (properties) {
            const currentProp = properties[propId];
            const propValues = currentProp.values;
      
            propValues.forEach((data, index) => {
              const isSelected = index === id;
              data.isSelected = isSelected;
      
              if (isSelected) {
                const selVal = data.value;
                const valName= data.name;
                const selType = currentProp.type;
                const selName = currentProp.name;
      
                const existing = selectedProperties.find(p => p.type === selType);
                if (existing) {
                  existing.value = selVal;
                  existing.value_name= valName
                } else {
                  selectedProperties.push({
                    name: selName,
                    type: selType,
                    value: selVal,
                    value_name: valName
                  });
                }
              }
            });
      
            // Assign updated propValues back
            properties[propId].values = propValues;
          }
      
          clone.selectedProperties = selectedProperties;

          // console.log('Clone',clone)
      
          return {
            ...clone,
            properties,
          };
        });
      };
      

    return (
        <>
            {/* <div className='eachprop'> */}
                <div className='title'>{prop.name}</div>
                <div className='value'>

                    {prop.type === 'size' && (
                        <div className="sizesPack">
                            {prop.values.map((data, id) => (
                                <div className={`eachSize ${data.isSelected ? 'active' : ''}`} key={id} onClick={()=>handlePropSelect(id)}>
                                    {data.value}
                                </div>
                            ))}
                        </div>
                    )}


                    {prop.type === 'color' && (
                        <div className="colorPack">
                            {prop.values.map((data, id) => (
                                <div className={`eachColor ${data.isSelected ? 'active' : ''}`} key={id} onClick={()=>handlePropSelect(id)}>
                                    <div className="colorbox" style={{backgroundColor: data.value}}></div>
                                </div>
                            ))}
                        </div>
                    )}

                </div>
            {/* </div> */}
        </>
    )
}

export default RenderProperty;